import { action, observable, computed } from 'mobx';
import getCurrencyVolatility from '../services/ratesService';
import moment from 'moment';
import _ from 'lodash';

class DataStore {
  constructor() {
    this.setBookingDate     = this.setBookingDate.bind(this);
    this.setPaymentDate     = this.setPaymentDate.bind(this);
    this.setBookingCurrency = this.setBookingCurrency.bind(this);
    this.setPaymentCurrency = this.setPaymentCurrency.bind(this);
    this.setProfitMargin    = this.setProfitMargin.bind(this);
    this.setDealAmount      = this.setDealAmount.bind(this);
    this.togglePaymentCurrencyIsBase      = this.togglePaymentCurrencyIsBase.bind(this);
    this.getRiskCalculations = this.getRiskCalculations.bind(this);
  }

  @observable data =  {
    bookingDate: null,
    bookingCurrency: null,
    paymentDate: null,
    paymentCurrency: null,
    profitMargin: null,
    dealAmount: null,
    paymentCurrencyIsBase: null,
    isCalculated: false,
    averageVol: 0,
    maxVol: 0,
    medianVol: 0
  };


  @computed get paymentCurrencyIsBase() {
    return this.data.paymentCurrencyIsBase;
  }

  @action togglePaymentCurrencyIsBase() {
    this.data.paymentCurrencyIsBase = !this.data.paymentCurrencyIsBase;
    this.data.isCalculated = false;
  }

  @computed get profitMargin() {
    return this.data.profitMargin;
  }

  @action setProfitMargin(value){
    if (_.isNumber(value)) {
      this.data.profitMargin = value;
      this.data.isCalculated = false;
    }
  }

  @computed get dealAmount() {
    return this.data.dealAmount;
  }

  @action setDealAmount(value) {
    if (_.isNumber(value)) {
      this.data.dealAmount = +value;
      this.data.isCalculated = false;
    }
  }

  @computed get bookingDate() {
    return this.data.bookingDate;
  };

  @action setBookingDate(date) {
    this.data.bookingDate = date;
    this.data.isCalculated = false;
  }

  @computed get paymentDate() {
    return this.data.paymentDate;
  };

  @action setPaymentDate(date) {
    this.data.paymentDate = date;
    this.data.isCalculated = false;
  }

  @computed get riskPeriod() {
    if (this.data.paymentDate && this.data.bookingDate) {
      return moment(this.data.paymentDate).diff(moment(this.data.bookingDate),'days');
    }

    return '';
  }

  @computed get bookingCurrency(){
    return this.data.bookingCurrency;
  }

  @action setBookingCurrency(value) {
    this.data.bookingCurrency = value;
    this.data.isCalculated = false;
  }

  @computed get paymentCurrency(){
    return this.data.paymentCurrency;
  }

  @action setPaymentCurrency(value) {
    this.data.paymentCurrency = value;
    this.data.isCalculated = false;
  }

  @computed get isCalculated() {
    return this.data.isCalculated;
  }

  @computed get averageVol() {
    return this.data.averageVol;
  }

  @computed get maxVol() {
    return this.data.maxVol;
  }

  @computed get medianVol() {
    return this.data.medianVol;
  }

  @computed get avgMarginAtRisk() {
    return (this.data.averageVol/this.data.profitMargin*100).toFixed(0);
  }

  @computed get maxMarginAtRisk() {
    return (this.data.maxVol/this.data.profitMargin*100).toFixed(0);
  }

  @computed get medianMarginAtRisk() {
    return (this.data.medianVol/this.data.profitMargin*100).toFixed(0);
  }

  @action getRiskCalculations() {
    const {maxVol, averageVol, medianVol} =
            getCurrencyVolatility(this.data.paymentCurrency, this.data.bookingCurrency, this.riskPeriod);
    if (averageVol && maxVol && medianVol) {
      this.data.maxVol = maxVol;
      this.data.averageVol = averageVol;
      this.data.medianVol = medianVol;
      this.data.isCalculated = true;
    }

  }
}

const todoStore = title => {
  return {
    @observable title: title,
    @observable finished: false,
    id: Math.random()
  };
};

const todoListStore = {
  @observable todos: [],
  @computed get unfinishedTodoCount() {
    return todoListStore.todos.filter(todo => !todo.finished).length;
  }
};

const dataStore = new DataStore();

export { dataStore, todoStore, todoListStore} ;



// WEBPACK FOOTER //
// ./src/stores/data-store.js